import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Grid, Button, Box, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import axios from "axios"
/**================================================================================================== */

const Sunday = ({date,checked,id,desc}) => {
  const user=localStorage.getItem("isAuthenticated")
    let navigate = useNavigate();

  const [tate, settate] = React.useState("");
  const dateDay=date.toLocaleDateString();
  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon
          sx={{ backgroundColor: "yellowgreen", fontSize: 30, p: 0.4 }}
        />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot
        </Typography>
      </Box>
      {tate ? (
        <p>
          <h5>{tate}</h5> <h6>on</h6> <h5>{date.toLocaleDateString()}</h5>
        </p>
      ) : (
        ""
      )}
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be rescheduled from <b>"old slot"</b>
            {" ------> "}
            <b>{tate}</b> on <b>{date.toLocaleDateString()}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
                      const obj = {
                        slot:tate+" "+dateDay,
                        rescheduled: true,
                        rescheduleReasonAuto: checked,
                        rescheduleReasonManual:desc,
                        reporterType:user.role,
                        reschedulePage:"reschedule_page"
                      };
                      axios
                        .patch(
                          `${process.env.REACT_APP_SERVER_URL}/api/edit/${id}`,
                          obj
                        )
                        .then((response) => {
                          console.log(response.status);
                          console.log(response.data);
                          handleClickClose()
                          //navigate('/')
                        });

                      }}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
/**================================================================================================== */

const Monday = (date) => {
  const [tate, settate] = React.useState("");

  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon sx={{ backgroundColor: "yellowgreen", fontSize: 30 }} />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot:
        </Typography>
        {tate ? (
          <p>
            <b>{tate}</b> on <b>{date.date}</b>
          </p>
        ) : (
          ""
        )}
      </Box>
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be reschedule from <b>"old slot"</b>
            {" ------> "}
            <b>{tate}</b> on <b>{date.date}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
/**================================================================================================== */

const Tuesday = (date) => {
  const [tate, settate] = React.useState("");

  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon sx={{ backgroundColor: "yellowgreen", fontSize: 30 }} />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot:
        </Typography>
        {tate ? (
          <p>
            <b>{tate}</b> on <b>{date.date}</b>
          </p>
        ) : (
          ""
        )}
      </Box>
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be reschedule from <b>"old slot"</b>
            {" ------> "}
            <b>{tate}</b> on <b>{date.date}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
/**================================================================================================== */

const Wednesday = (date) => {
  const [tate, settate] = React.useState("");

  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon sx={{ backgroundColor: "yellowgreen", fontSize: 30 }} />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot:
        </Typography>
        {tate ? (
          <p>
            <b>{tate}</b> on <b>{date.date}</b>
          </p>
        ) : (
          ""
        )}
      </Box>
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be reschedule from <b>"old slot"</b>
            {" ------> "}
            <b>{tate}</b> on <b>{date.date}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
/**================================================================================================== */

const Thursday = (date) => {
  const [tate, settate] = React.useState("");

  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon sx={{ backgroundColor: "yellowgreen", fontSize: 30 }} />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot:
        </Typography>
        {tate ? (
          <p>
            <b>{tate}</b> on <b>{date.date}</b>
          </p>
        ) : (
          ""
        )}
      </Box>
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be reschedule from <b>"old slot"</b>
            {" ------> "}
            <b>{tate}</b> on <b>{date.date}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
/**================================================================================================== */

const Friday = (date) => {
  const [tate, settate] = React.useState("");

  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon sx={{ backgroundColor: "yellowgreen", fontSize: 30 }} />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot:
        </Typography>
        {tate ? (
          <p>
            <b>{tate}</b> on <b>{date.date}</b>
          </p>
        ) : (
          ""
        )}
      </Box>
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be reschedule from <b>"old slot"</b> {"------>"}{" "}
            <b>{tate}</b> on <b>{date.date}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
/**================================================================================================== */

const Saturday = (date) => {
  const [tate, settate] = React.useState("");

  const handleChange = (ev) => {
    settate(ev.target.value);
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };
  return (
    <>
      <FormControl component="fieldset" name="method-of-payment">
        <RadioGroup onChange={handleChange} value={tate}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <FormControlLabel
                value="09:30 AM-10:15 AM"
                control={<Radio />}
                label="9:30 AM-10:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="01:30 AM-02:15 AM"
                control={<Radio />}
                label="1:30 AM-2:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="10:30 AM-11:15 AM"
                control={<Radio />}
                label="10:30 AM-11:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="2:30 AM-3:15 AM"
                control={<Radio />}
                label="2:30 AM-3:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="6:30 AM-7:15 AM"
                control={<Radio />}
                label="6:30 AM-7:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                value="5:30 AM-6:15 AM"
                control={<Radio />}
                label="5:30 AM-6:15 AM"
                sx={{
                  pr: 1,
                  backgroundColor: "orange",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", mt: 3, p: 1 }}>
        <AccessTimeIcon sx={{ backgroundColor: "yellowgreen", fontSize: 30 }} />
        <Typography
          sx={{
            backgroundColor: "yellowgreen",
            mr: 1,
            fontSize: 20,
            pl: 0.5,
            pr: 0.5,
          }}
        >
          New Slot:
        </Typography>
        {tate ? (
          <p>
            <b>{tate}</b> on <b>{date.date}</b>
          </p>
        ) : (
          ""
        )}
      </Box>
      <Button sx={{ mt: 2 }} variant="outlined" onClick={handleClickOpen}>
        Reschedule your Mock Interview
      </Button>
      <Dialog
        open={open}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert">
          {"Are you sure to Reschedule your Mock Interview?"}
        </DialogTitle>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <CloseIcon onClick={handleClickClose} />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your interview will be reschedule from <b>"old slot"</b>
            {" ------> "}
            <b>{tate}</b> on <b>{date.date}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Yes</Button>
          <Button onClick={handleClickClose}>No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export { Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday };
